<div #canvasError></div>